import type TableQuery from './TableQuery';
import { type TableQueryType } from './TableQuery';
import type ReactListViewType from 'owa-service/lib/contract/ReactListViewType';

// In this type, we will add other properties specific to Copilot Results Table Query in future if needed
// such as the Prompt used to generate the Copilot Results so that it can be displayed/persisted, etc.
export type CopilotResultsTableQuery = TableQuery;

export function createCopilotResultsTableQuery(): CopilotResultsTableQuery {
    return {
        folderId: 'CopilotResultsFolder', // [TODO: sopai, asarangi]: Copilot Results do not belong to any specific folder but we will want to make this unique per prompt in the future
        listViewType: 1, // Force into Item view as we only have access to ItemIds from Bizchat results
        type: 4,
    };
}

export function isCopilotResultsTable(tableQuery: TableQuery | undefined): boolean {
    if (!tableQuery) {
        return false;
    }
    return tableQuery.type === 4;
}
